export function downloadExcelTemplate(path){
	window.open(path, '_parent')
}